import React from 'react';


export class UserCard extends React.PureComponent{
    render(){
        return (
            <div className="card card-user">
                <div className="image" style={{background:'url('+this.props.bgImage+')', backgroundSize:'cover',height:'150px'}}>
                    <img src={this.props.bgImage} style={{backgroundSize:'cover'}} alt="..."/>
                </div>
                <div className="content">
                    <div className="author">
                         <a href="#pablo">
                            <img className="avatar border-gray" src={this.props.avatar} alt="..."/>
                            <h4 className="title">
                                {this.props.name}
                                <br />
                                <small>{this.props.userName}</small>
                            </h4>
                        </a>
                    </div>
                    <p className="description text-center">
                        {this.props.description}
                    </p>
                </div>
                <hr />
                <div className="text-center">
                    {this.props.socials}
                </div>
            </div>
        );
    }
}

export default UserCard;
